export default __webpack_public_path__ + "assets/apple-touch-icon-57x57-9a44370.png";